import { useI18n } from '@platform/i18n';
import { InboxRulesBody, PageBody, PageHeader } from '@platform/ui';
import { api } from '../api';
import { SettingsTabs } from './settings-tabs';

export function InboxRulesPage() {
  const { t } = useI18n();
  return <div className="min-h-0 flex-1 overflow-y-auto">
    <PageHeader title={t('inboxRules.title')} tabs={<SettingsTabs active="inbox-rules" />} />
    <PageBody width="form"><InboxRulesBody load={()=>api.myInboxRules()} save={input=>api.saveMyInboxRules(input)} targetKey="personal" nativeTable /></PageBody>
  </div>;
}
